'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('housing', {
      url: '/account/housing',
      template: '<housing></housing>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/housing/housing.routes.js